<div class="viewcontainer">
    <div class="head">
        <app-header [Message]="Header" [Action]="ButtonAction" [Visible]='visible' [ConfirmHead]='confirmHeading' [Confirmbody]='confirmBody' (exposeChild)="showDataFromChild($event)"></app-header>
    </div>
    <div class="flex-containter">
        <div class="container">
            <div class="formGroup formRow">
                <div class="formGroup">
                  <label>Unit (SI / US)</label>
                  <select [(ngModel)]="selUnit" (change)="toggleUnit()" class="dropdown-modify">
                      <option disabled selected value=''></option>
                      <option *ngFor="let item of programSettingService.unitList" [ngValue]="item.value">{{item.display}}</option>
                  </select>
                </div>
            </div>
            <div class="formGroup">
              <!-- <label>Concentration (ppb / µg/m³)</label> -->
              <label>Concentration (ppb / mg/m³)</label>
              <select [(ngModel)]="selConcUnit" class="dropdown-modify">
                  <option disabled selected value=''></option>
                  <option *ngFor="let item of programSettingService.concUnitList" [ngValue]="item">{{item}}</option>
              </select>
            </div>
            <div class="formGroup">
                <!-- <label>Airflow (m³/h / CFM / m³/s / L/s)</label> -->
                <label>{{AirFlowLabel}}</label>
                <select [(ngModel)]="selAirFlowUnit" [disabled]="disableFlag" class="dropdown-modify">
                    <option disabled selected value=''></option>
                    <option *ngFor="let item of programSettingService.airFlowUnitList" [ngValue]="item">{{item}}</option>
                </select>
            </div>
            <div class="formGroup">
              <label>Format</label>
              <select [(ngModel)]="selFormat"  class="dropdown-modify">
                  <option disabled selected value=''></option>
                  <option *ngFor="let item of programSettingService.formatList" [ngValue]="item">{{item}}</option>
              </select>
            </div>
        </div>
    </div>
  </div>

